import { Component, inject, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IInHomeCareLicense } from 'app/models/licenses/in-home-care/in-home-care-license';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SharedService } from '@shared/services/shared.service';

@Component({
  selector: 'app-subunit-details-dialog',
  templateUrl:'./dialog-subunit-details.component.html',
  styleUrls: ['./dialog-subunit-details.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*', visibility: 'visible' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
  ]
})
export class SubunitDetailsDialogComponent {
  subunits: IInHomeCareLicense[];
  displayedColumns: string[] = ['licenseId', 'entityName', 'classificationLevel', 'expirationDate', 'expand'];
  expandedElement: IInHomeCareLicense | null = null;

  constructor(public dialogRef: MatDialogRef<SubunitDetailsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: { subunits: IInHomeCareLicense[] })
  {
    this.subunits = data.subunits || [];
  }

  public sharedService = inject(SharedService);

  toggleExpanded(subunit: IInHomeCareLicense): void {
    this.expandedElement = this.expandedElement === subunit ? null : subunit;
  }

  close(): void {
    this.dialogRef.close();
  }
}
